import axios from "axios";
import { useState, useRef } from "react";
import QRCode from "react-qr-code";

function ConfirmSendStep({
  eodIds,
  onNext,
  onBack,
  url,
  barcodes,
  submissionId,
  totalCouponsCost,
}) {
  const [sending, setSending] = useState(false);
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [isImagesUploaded, setIsImagesUploaded] = useState(false);
  const [message, setMessage] = useState();

  const handleSubmit = async () => {
    setSending(true);
    const params = {
      dbObjId: submissionId,
      totalCouponsCost: totalCouponsCost,
      barcodes:barcodes
    };
    
    await axios
      .post(`${url}/coupons/submissions/finalize`, params)
      .then((res) => {
        if(res.data.success === true){
          onNext();
        }
      })
      .catch((error) => {
        console.log("Submming error", error);
      });
    onNext();
  };

  const handleImageCheck = async () => {
    setMessage()
    const params = { dbObjId: submissionId };
    await axios
      .post(`${url}/coupons/images/check`, params)
      .then((res) => {
        if (res.data.success) {
          setIsImagesUploaded(true);
        } else {
          setMessage("Images not found");
        }
      })
      .catch((error) => {
        console.log("Fetch error", error);
      });
  };

  return (
    <div className="menzies-wizard">
      <h2 className="text-xl font-semibold mb-4">Step 3: Confirm & Send</h2>
      <p className="mb-4">Please attach photo of envelope</p>
      <p>Barcodes quantity: {barcodes.length}</p>
      <div
        style={{
          maxHeight: barcodes.length > 10 ? "400px" : "auto",
          overflowY: barcodes.length > 10 ? "scroll" : "visible",
        }}
      >
        <table>
          <thead>
            <tr>
              <th>Barcode</th>
            </tr>
          </thead>
          <tbody>
            {barcodes.map((barcode, i) => (
              <tr key={i}>
                {barcode.imgFormat ? <td>{barcode.imgFormat}</td> : null}
                {barcode.image ? <td>{barcode.image}</td> : null}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <QRCode
        value={`https://nitropos.co.uk/managerzone/eod/menzies-images?id=${submissionId}`}
        size={256}
        style={{ padding: "10px" }}
      />

      {message && <p style={{ color: "black", }}>{message}</p>}
      <div className="button-group ">
        <button className="btn" onClick={onBack}>
          ← Back
        </button>
        {!isImagesUploaded && (
          <button className="btn" onClick={handleImageCheck}>
            Check images
          </button>
        )}
        {isImagesUploaded && (
          <button
            className="btn btn-success"
            onClick={handleSubmit}
            disabled={sending}
          >
            {sending ? "Sending..." : "Send to Menzies"}
          </button>
        )}
      </div>
    </div>
  );
}
export default ConfirmSendStep;
